import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Factory, ArrowUpRight } from "lucide-react";
import { api, fmtNum } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PlantSetupBanner() {
  const { can } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/plants/setup-status").then((r) => setS(r.data)); }, []);
  if (!s || !s.count) return null;
  return (
    <div className="mb-5 rounded-xl border border-slate-200 border-l-4 border-l-[#D52B3B] bg-white px-4 py-3 shadow-[0_1px_2px_rgba(15,23,42,0.04)] fade-up" data-testid="plant-setup-banner">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <Factory className="h-4 w-4 text-[#661D1D]" />
        <p className="text-sm font-semibold text-slate-800" data-testid="plant-setup-count">{s.count} plant{s.count > 1 ? "s" : ""} need setup</p>
        <p className="text-xs text-slate-500" data-testid="plant-setup-lines">{fmtNum(s.sales_lines)} sales line{s.sales_lines === 1 ? "" : "s"} flagged “Plant needs setup”</p>
        {!can.admin && <p className="ml-auto text-xs font-medium text-slate-600" data-testid="plant-setup-ask-admin">Ask an admin to finish plant setup</p>}
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {s.plants.map((p) => {
          const body = (<><span className="font-mono font-semibold">{p.code}</span><span className="text-slate-500">missing {p.missing.join(", ")}</span>
            {p.sales_lines > 0 && <span className="rounded bg-slate-100 px-1 text-[10px] font-semibold text-slate-700">{p.sales_lines} lines</span>}
            {can.admin && <ArrowUpRight className="h-3 w-3 text-[#D52B3B]" />}</>);
          const cls = "inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-[11px]";
          return can.admin
            ? <Link key={p.code} to={`/plants?edit=${encodeURIComponent(p.code)}`} className={`${cls} transition-colors hover:border-[#D52B3B]/40 hover:bg-white`} data-testid={`plant-setup-link-${p.code}`}>{body}</Link>
            : <span key={p.code} className={cls} data-testid={`plant-setup-item-${p.code}`}>{body}</span>;
        })}
      </div>
    </div>
  );
}
